import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ToasterService } from '../../../service/common/toaster.service';
import { CommonService, CrudComponent } from 'wire-frame';

import { TagModule } from 'primeng/tag';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { EditorModule } from 'primeng/editor';

import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';

import { SupplierService } from '../../../service/admin/supplier.service';

@Component({
  selector: 'app-Supplier',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    TagModule,
    ToggleButtonModule,
    DropdownModule,
    ToolbarModule,
    ConfirmDialogModule,
    CrudComponent,
    EditorModule,
    ButtonModule,
    TabViewModule,
  ],
  providers: [ConfirmationService, CommonService, SupplierService],
  templateUrl: './supplier.component.html',
  styleUrl: './supplier.component.scss'
})
export class SupplierComponent {
  activeIndex: number = 0;

  public SupplierList = [];
  public editRecord = null;

  public Supplier = {
    id: '',
    companyName: '',
    contactPerson: '',
    phoneNumber: '',
    emailAddress: '',
    address: '',


    gstNumber: '',
  panNumber: '',
  bankAccountNumber: '',
  bankName: '',
  ifscCode: '',
  upiId: ''
  };

  public closeFormEvent: boolean = false;
  public openDeletePopup: any = null;
  public activeMenu: string = 'basic';

  constructor(
    public common: CommonService,
    private toast: ToasterService,
    private confirmationService: ConfirmationService,
    private SupplierService: SupplierService
  ) {
    this.common.breadCrum = {
      title: 'Supplier',
      icon: 'users',
      list: ['Supplier'],
    };

    this.common.setCrudTableHeaders([
      {
        title: 'Company Name',
        val: 'companyName',
        id: 'id',
        showColumn: true,
        filterColmn: true,
        order: 'asc',
        searchColumn: true,
        type: 'string',
        globalSearch: true,
      },
      {
        title: 'Contact Person',
        val: 'contactPerson',
        id: 'id',
        showColumn: true,
        filterColmn: true,
        order: 'asc',
        searchColumn: true,
        type: 'string',
        globalSearch: true,
      },
      {
        title: 'Phone Number',
        val: 'phoneNumber',
        id: 'id',
        showColumn: true,
        filterColmn: false,
        order: 'asc',
        searchColumn: false,
        type: 'string',
        globalSearch: false,
      },
      {
        title: 'Email Address',
        val: 'emailAddress',
        id: 'id',
        showColumn: true,
        filterColmn: false,
        order: 'asc',
        searchColumn: false,
        type: 'string',
        globalSearch: false,
      },
      {
        title: 'Address',
        val: 'address',
        id: 'id',
        showColumn: true,
        filterColmn: false,
        order: 'asc',
        searchColumn: false,
        type: 'string',
        globalSearch: false,
      },
    ]);

    this.common.setCrudActions([
      {
        title: '',
        icon: 'pi-pencil',
        classArr: 'me-2',
        tooltip: 'Update Supplier',
      },
      { title: '', icon: 'pi-trash', tooltip: 'Delete Supplier' },
    ]);
  }
  ngOnInit() {
    this.getSupplier();
  }

  getSupplier() {
    this.SupplierService.getSupplier().subscribe((res: any) => {
      this.SupplierList = res.data;
    })
  }

  closeForm() {
    this.clearForm();
    this.closeFormEvent = true;
    setTimeout(() => {
      this.closeFormEvent = false;
    }, 1);
  }
  clearForm() { 
    this.Supplier = {
       id: '',
    companyName: '',
    contactPerson: '',
    phoneNumber: '',
    emailAddress: '',
    address: '',

    gstNumber: '',
  panNumber: '',
  bankAccountNumber: '',
  bankName: '',
  ifscCode: '',
  upiId: ''



        };
  }

  processSupplier() {
    if (this.Supplier?.id) {
      this.updateSupplier();
    } else {
      this.addSupplier();
    }
  }

  addSupplier() {
    this.SupplierService.addSupplier(this.Supplier).subscribe((res: any) => {
      if (res.status) {
        this.toast.add({ severity: 'success', summary: 'Success', detail: res.message });
        this.getSupplier();
        this.closeForm();
      } else {
        this.toast.add({ severity: 'error', summary: 'Error', detail: res.message });
      }
    });
  }

  updateSupplier() {
    this.SupplierService.updateSupplier(this.Supplier).subscribe((res: any) => {
      if (res.status) {
        this.toast.add({ severity: 'success', summary: 'Success', detail: res.message });
        this.getSupplier();
        this.closeForm();
      } else {
        this.toast.add({ severity: 'error', summary: 'Error', detail: res.message });
      }
    });
  }

  deleteSupplier(item: any) {
    this.SupplierService.deleteSupplier(item).subscribe((res: any) => {
      this.toast.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Visa Card deleted successfully',
      });

      this.getSupplier();
      this.closeForm();
    })
  }

  deleteRecord(event: any) {
    if(event) {
      this.deleteSupplier(event);
    }
  }

  handleEvent(event: any) {
    // console.log(event);
    if(event.action.tooltip == "Update Supplier") {
      this.editRecord = event.data;
      this.Supplier = event.data;
      setTimeout(() => {
        this.editRecord = null;
      }, 1);
    } else if(event.action.tooltip == "Delete Supplier") {
      this.editRecord = event.data;
      this.delRecPopupOpen({title: this.editRecord?.['first_name  '], obj: this.editRecord});
    }
  }

  delRecPopupOpen(item: any) {
    this.openDeletePopup = item;
    setTimeout(() => {
      this.openDeletePopup = null;
    }, 1);
  }

}
